/* BEVANUP_MOBILE_MENU_OVERLAY_V2 */
(() => {
  const install = () => {
    const menu = document.querySelector('.bevanup-mobile-menu');
    if (!menu || menu.dataset.bevanupOverlayV2 === 'true') return;
    menu.dataset.bevanupOverlayV2 = 'true';
    const bar = document.createElement('div');
    bar.className = 'bevanup-mobile-menu__overlay-topbar';
    const logo = document.createElement('a');
    logo.className = 'bevanup-mobile-menu__overlay-logo';
    logo.href = '/';
    logo.setAttribute('aria-label', 'BEVAN UP home');
    const sourceLogo = document.querySelector('.header-logo .header-logo__image-container, .header-logo img');
    if (sourceLogo) {
      const visual = sourceLogo.cloneNode(true);
      const sourceStyle = getComputedStyle(sourceLogo);
      Object.assign(visual.style, {
        backgroundImage: sourceStyle.backgroundImage,
        backgroundPosition: sourceStyle.backgroundPosition,
        backgroundRepeat: sourceStyle.backgroundRepeat,
        backgroundSize: sourceStyle.backgroundSize,
        color: 'transparent', display: 'block', fontSize: '0', height: sourceStyle.height,
        lineHeight: '0', width: sourceStyle.width,
      });
      logo.append(visual);
    } else logo.textContent = 'BEVAN UP';
    const close = document.createElement('button');
    close.className = 'bevanup-mobile-menu__overlay-close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Close menu');
    close.addEventListener('click', () => {
      menu.hidden = true;
      document.documentElement.classList.remove('bevanup-mobile-menu-open');
      document.querySelector('.header__icon--menu')?.setAttribute('aria-expanded', 'false');
    });
    const cart = document.createElement('a');
    cart.className = 'bevanup-mobile-menu__overlay-cart';
    cart.href = '/cart';
    cart.setAttribute('aria-label', 'Cart');
    let cartObserver;
    const syncCart = () => {
      const sourceCart = document.querySelector('cart-icon.header-actions__cart-icon');
      const bag = sourceCart?.querySelector('.bevanup-bag-icon')?.cloneNode(true);
      const count = sourceCart?.querySelector('.bevanup-cart-count')?.cloneNode(true);
      if (!bag || !count) return false;
      cart.replaceChildren(bag, count);
      if (!cartObserver) {
        cartObserver = new MutationObserver(syncCart);
        cartObserver.observe(sourceCart, { childList: true, characterData: true, subtree: true });
      }
      return true;
    };
    let cartAttempts = 0;
    const cartTimer = window.setInterval(() => {
      cartAttempts += 1;
      if (syncCart() || cartAttempts >= 20) window.clearInterval(cartTimer);
    }, 100);
    syncCart();
    bar.append(logo, close, cart);
    menu.prepend(bar);
  };
  const observe = () => {
    install();
    const observer = new MutationObserver(() => {
      install();
      if (document.querySelector('.bevanup-mobile-menu')) observer.disconnect();
    });
    observer.observe(document.body, { childList: true });
    window.setTimeout(install, 250);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true }); else observe();
})();
